import React from 'react';

import { cn } from '@change/ds-utils';

import type { ShareFeedItem as ShareFeedItemType } from 'src/app/pages/psf/share/pageContext';

import { ShareFeedItem } from './components/ShareFeedItem';
import { useShareFeed } from './hooks/useShareFeed';

const DEFAULT_INTERVAL_SECONDS = 3;

export const ShareFeed: React.FC<Props> = ({ items, intervalSeconds = DEFAULT_INTERVAL_SECONDS }) => {
	const scrollerRef = useShareFeed(intervalSeconds);

	return (
		<div className="relative">
			<div
				ref={scrollerRef}
				className="ml-6 flex snap-x snap-proximity flex-row gap-3 overflow-x-hidden scroll-smooth whitespace-nowrap md:ml-10"
			>
				{items.map((item, index) => (
					<ShareFeedItem
						item={item}
						key={item.id}
						// Large margin-right on last item extends scrollable area, ensuring it's fully visible past the gradient overlay
						className={cn('snap-start', { 'mr-120': index === items.length - 1 })}
					/>
				))}
			</div>
			<div
				aria-hidden
				className="pointer-events-none absolute top-0 h-full w-full bg-[linear-gradient(to_right,transparent_80%,white)]"
			/>
		</div>
	);
};

type Props = Readonly<{
	intervalSeconds?: number;
	items: readonly ShareFeedItemType[];
}>;
